export default __webpack_public_path__ + "static/tbba-logo-66abb0e1f069d194ba612603c796aa6d.png";